import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import AlertMessage from 'components/UI/V3/AlertMessage';
import { MarketingLoyaltyPath } from 'routes/Paths';
import styles from './LoyaltyInactiveWarning.module.scss';

const LoyaltyInactiveWarning: FunctionComponent = () => (
    <AlertMessage
        icon={faCircleInfo}
        bgColor="#F8F5F1"
        bdColor="#BCB8AE"
        iconColor="#BAA997"
        bWidth="2px"
    >
        <div className={styles.content}>
            <p className={styles.title}>Loyalty is currently disabled</p>
            <p className={styles.body}>
                Enable{' '}
                <Link
                    className={styles.link}
                    to={MarketingLoyaltyPath}
                >
                    loyalty
                </Link>{' '}
                rewards in Marketing to start tracking points for this client.
            </p>
        </div>
    </AlertMessage>
);

export default LoyaltyInactiveWarning;
